export default __webpack_public_path__ + "static/veniprotekt-d90d4b4460e051712176719ef032724a.jpg";